var _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUsJoinNow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 255,
    viewBox: "0 0 280 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 255,
    rx: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 15,
    y: 19,
    width: 250,
    height: 38,
    rx: 19,
    fill: "#DBDED9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_361_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8333 37.7083C41.8333 39.1175 41.4154 40.4951 40.6325 41.6668C39.8496 42.8385 38.7369 43.7517 37.4349 44.291C36.133 44.8302 34.7004 44.9713 33.3183 44.6964C31.9362 44.4215 30.6666 43.7429 29.6702 42.7465C28.6737 41.75 27.9951 40.4805 27.7202 39.0983C27.4453 37.7162 27.5864 36.2836 28.1257 34.9817C28.6649 33.6798 29.5782 32.567 30.7499 31.7841C31.9216 31.0012 33.2991 30.5833 34.7083 30.5833C36.598 30.5833 38.4103 31.334 39.7465 32.6702C41.0826 34.0064 41.8333 35.8187 41.8333 37.7083V37.7083Z",
    stroke: "#39342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9862 45.3796C41.4058 46.6463 42.3637 46.7729 43.1 45.6646C43.7729 44.6513 43.3296 43.82 42.1104 43.82C41.9168 43.8013 41.7217 43.8337 41.5446 43.9139C41.3674 43.9941 41.2143 44.1193 41.1006 44.2771C40.9869 44.4348 40.9165 44.6197 40.8964 44.8131C40.8764 45.0065 40.9073 45.2018 40.9862 45.3796V45.3796Z",
    stroke: "#39342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 74.5,
    width: 249,
    height: 68,
    rx: 10.5,
    stroke: "#DBDED9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 154.5,
    width: 249,
    height: 68,
    rx: 10.5,
    stroke: "#DBDED9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 94,
    width: 166,
    height: 4.62,
    rx: 2.31,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 108.189,
    width: 113.741,
    height: 4.62,
    rx: 2.31,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 122.378,
    width: 73.7778,
    height: 4.62,
    rx: 2.31,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 111.545,
    width: 17.8182,
    height: 17.8182,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5909 88L60.7864 105.659H40.3954L50.5909 88Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.0909,
    cy: 120.455,
    r: 8.90909,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_361_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(26 29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsJoinNow);
export default __webpack_public_path__ + "static/media/AboutUsJoinNow.63d01cb4d33f569f93a6859f98041745.svg";
export { ForwardRef as ReactComponent };